import { PlusCircle } from 'lucide-react'
import { useFlowStore } from '../store'

export const SelectTrigger = () => {
  const setShowTriggerDialog = useFlowStore((state) => state.setShowTriggerDialog)
  return (
    <div className="relative nodrag cursor-default bg-background nowheel">
      <button
        className="flex flex-col gap-1 px-[54px] py-6 rounded-2xl border-2 border-dashed border-st2"
        onClick={() => setShowTriggerDialog(true)}
        type="button"
      >
        <div className="flex items-center gap-2 text-tertiary">
          <PlusCircle size={16} className="text-muted-foreground" />
          <p className="text-p-600">Select Trigger</p>
        </div>
      </button>
    </div>
  )
}
